import { Box } from '@mui/material';
import { useState, useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { ComposableDashboardFiltersEnum, IComposableAnalyticsGlobalFilters } from 'wisestep-api';
import { ScrollableTabs, WsTitleBanner } from 'wisestep-base';

import { PinDashboardCollectionButton } from '../../../components';
import { WsBreadCrumbs } from '../../../components/WsBreadCrumbs';
import UserProfileOverview from '../../../features/recruiterProfileDetails/components/userProfile/UserProfileOverview';
import {
  getSettingBreadCrumbList,
  ISettingBreadCrumbTypes,
  Pages,
} from '../../../features/teams/helper/defaultValues';
import { getBreadCrumbWithLabel } from '../../../features/users/helper/defaultValues';
import getDecodedQueryParams from '../../../utils/getDecodedQueryParams';

import BusinessUnitDescriptionTab from './BusinessUnitDescriptionTab';
import BusinessUnitUsersTab from './BusinessUnitUsersTab';

const tabs = [
  {
    tabName: 'Analytics',
  },
  {
    tabName: 'Description',
  },
  {
    tabName: 'Users',
  },
];

const BusinessUnitUsersView = () => {
  const location: any = useLocation();
  const [param] = useSearchParams();
  const data = param.get('state') ?? '';
  const { state } = location;

  const {
    businessUnitDescription: buDescription,
    businessUnitId: buId,
    businessUnitName,
    isSetting,
  } = state ?? getDecodedQueryParams(data);

  const [tabIndex, setTabIndex] = useState<number>(0);

  const getFilters = useMemo(() => {
    const filters = {} as Record<ComposableDashboardFiltersEnum, IComposableAnalyticsGlobalFilters>;
    filters[ComposableDashboardFiltersEnum.TEAM] = { teamIds: [buId] };
    return filters;
  }, [buId]);

  return (
    <>
      <WsBreadCrumbs
        breadCrumbsList={[
          ...(isSetting
            ? getSettingBreadCrumbList(
                ISettingBreadCrumbTypes.TEAMS_AND_USERS,
                Pages['BUSINESS_UNITS']
              )
            : [{ label: 'Dashboards', url: '/workspace-users-and-teams/bussiness-units' }]),
          getBreadCrumbWithLabel(businessUnitName),
        ]}
      />
      <Box>
        <WsTitleBanner
          title={businessUnitName}
          backButton={false}
          rightChildren={
            <PinDashboardCollectionButton
              filters={getFilters}
              entityId={buId}
              entityName={businessUnitName}
            />
          }
        />
      </Box>
      <ScrollableTabs scrollList={tabs} getTabIndex={(index: number) => setTabIndex(index)} />
      {tabIndex == 0 && <UserProfileOverview tabIndex={tabIndex} businessUnitId={buId} />}
      {tabIndex == 1 && <BusinessUnitDescriptionTab buDescription={buDescription} />}
      {tabIndex == 2 && <BusinessUnitUsersTab BusinessUnitId={buId} />}
    </>
  );
};
export default BusinessUnitUsersView;
